export default "__VITE_ASSET__BcxRmjXZ__"